const GOLDEN_MAIL = {
  slug: "golden-mail",
  name: "Golden Mail",
  description: "Plated with gold leaf",
  rarity: "uncommon",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 12 },
    { stat: "goldColor", value: 5 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_yellow",
    frameIndex: 0
  },
  bodySprite: "characters/body/body_gold",
  tags: ["daily-rotation", "metal"]
};
export {
  GOLDEN_MAIL
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC9nb2xkZW4tbWFpbC50cyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiaW1wb3J0IHsgSXRlbURlZmluaXRpb24gfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBjb25zdCBHT0xERU5fTUFJTDogSXRlbURlZmluaXRpb24gPSB7XG4gIHNsdWc6ICdnb2xkZW4tbWFpbCcsXG4gIG5hbWU6ICdHb2xkZW4gTWFpbCcsXG4gIGRlc2NyaXB0aW9uOiAnUGxhdGVkIHdpdGggZ29sZCBsZWFmJyxcbiAgcmFyaXR5OiAndW5jb21tb24nLFxuICBzbG90OiAnYXJtb3InLFxuICBzaG9wQ2F0ZWdvcnk6ICdtZXRhbC1hcm1vcicsXG4gIHN0YXRDaGFuZ2VzOiBbXG4gICAgeyBzdGF0OiAnYXJtb3InLCB2YWx1ZTogMTIgfSxcbiAgICB7IHN0YXQ6ICdnb2xkQ29sb3InLCB2YWx1ZTogNSB9LFxuICBdLFxuICBzcHJpdGU6IHtcbiAgICBzaGVldDogJ3dhcmRyb2JlL21ldGFsL21ldGFsX3llbGxvdycsXG4gICAgZnJhbWVJbmRleDogMCxcbiAgfSxcbiAgYm9keVNwcml0ZTogJ2NoYXJhY3RlcnMvYm9keS9ib2R5X2dvbGQnLFxuICB0YWdzOiBbJ2RhaWx5LXJvdGF0aW9uJywgJ21ldGFsJ10sXG59O1xuIl0sCiAgIm1hcHBpbmdzIjogIkFBRU8sTUFBTSxjQUE4QjtBQUFBLEVBQ3pDLE1BQU07QUFBQSxFQUNOLE1BQU07QUFBQSxFQUNOLGFBQWE7QUFBQSxFQUNiLFFBQVE7QUFBQSxFQUNSLE1BQU07QUFBQSxFQUNOLGNBQWM7QUFBQSxFQUNkLGFBQWE7QUFBQSxJQUNYLEVBQUUsTUFBTSxTQUFTLE9BQU8sR0FBRztBQUFBLElBQzNCLEVBQUUsTUFBTSxhQUFhLE9BQU8sRUFBRTtBQUFBLEVBQ2hDO0FBQUEsRUFDQSxRQUFRO0FBQUEsSUFDTixPQUFPO0FBQUEsSUFDUCxZQUFZO0FBQUEsRUFDZDtBQUFBLEVBQ0EsWUFBWTtBQUFBLEVBQ1osTUFBTSxDQUFDLGtCQUFrQixPQUFPO0FBQ2xDOyIsCiAgIm5hbWVzIjogW10KfQo=
